import "./sdk.gen-s8MJGGfo.js";
//#region src/generated/types.gen.ts
var e = { VASCO: "VASCO" }, t = { STATUS: "status" }, n = {
	ASC: "ASC",
	DESC: "DESC"
}, r = {
	CANCELED: "CANCELED",
	COMPLETED: "COMPLETED",
	CONCEPT: "CONCEPT",
	PARTIALLY_RECEIVED: "PARTIALLY_RECEIVED",
	REGISTERED: "REGISTERED",
	REGISTRATION_REQUESTED: "REGISTRATION_REQUESTED"
}, i = {
	Container: "CONTAINER",
	Pallet: "PALLET",
	Package: "PACKAGE"
}, a = (e) => e.status === "CONCEPT", o = (e) => e.status === "PARTIALLY_RECEIVED", s = (e) => e.status === "REGISTRATION_REQUESTED", c = (e) => e.status === "REGISTERED", l = (e) => e.status === "COMPLETED", u = (e) => e.status === "CANCELED", d = (e) => a(e) || c(e) || s(e);
//#endregion
export { c as a, i as c, r as d, n as f, o as i, e as l, l as n, s as o, a as r, d as s, u as t, t as u };
